module.exports = __webpack_public_path__ + "img/ico4.34e1f049.png";